import type { AutocompleteOption } from 'shared/search/types';
import { formatISODate } from 'shared/util/datetime-fns';
import type { Filters } from '@/domain';

type HiddenSearchInputsProps = {
    filters: Filters;
    destinationData?: AutocompleteOption | null;
    numOfBedrooms?: number;
    numOfBeds?: number;
    startDate?: Date | null;
    endDate?: Date | null;
};

export const HiddenSearchInputs = ({ destinationData, numOfBedrooms, numOfBeds, filters, startDate, endDate }: HiddenSearchInputsProps) => (
    <>
        {destinationData &&
            (destinationData.bounds ? (
                <>
                    <input type="hidden" name="lat_ne" value={destinationData.bounds.northeast_lat} />
                    <input type="hidden" name="lat_sw" value={destinationData.bounds.southwest_lat} />
                    <input type="hidden" name="lng_ne" value={destinationData.bounds.northeast_lng} />
                    <input type="hidden" name="lng_sw" value={destinationData.bounds.southwest_lng} />
                    <input type="hidden" name="country" value={destinationData.country} />
                    <input type="hidden" name="city" value={destinationData.city ? destinationData.city : ''} />
                </>
            ) : (
                <input type="hidden" name="destination" value={destinationData.text} />
            ))}

        <input type="hidden" name="no_of_bedrooms_from" value={numOfBedrooms ?? 1} />
        <input type="hidden" name="no_of_beds_from" value={numOfBeds ?? 1} />

        {startDate && <input type="hidden" name="booking_from" value={formatISODate(startDate)} />}
        {endDate && <input type="hidden" name="booking_to" value={formatISODate(endDate)} />}

        {filters && (
            <>
                {filters.is_private ? <input type="hidden" name="is_private" value={filters.is_private?.toString()} /> : null}
                {filters.is_transactional ? (
                    <input type="hidden" name="is_transactional" value={filters.is_transactional?.toString()} />
                ) : null}
                {filters.price_from ? <input type="hidden" name="price_from" value={filters.price_from} /> : null}
                {filters.price_to ? <input type="hidden" name="price_to" value={filters.price_to} /> : null}
                {Array.isArray(filters.property_types)
                    ? filters.property_types.map((typ) => <input type="hidden" name="property_types" value={typ} key={typ} />)
                    : null}
                {Array.isArray(filters.house_rules)
                    ? filters.house_rules.map((typ) => <input type="hidden" name="house_rules" value={typ} key={typ} />)
                    : null}
                {Array.isArray(filters.facilities)
                    ? filters.facilities.map((typ) => <input type="hidden" name="facilities" value={typ} key={typ} />)
                    : null}
                {Array.isArray(filters.pois_nearby)
                    ? filters.pois_nearby.map((typ) => <input type="hidden" name="pois_nearby" value={typ} key={typ} />)
                    : null}
            </>
        )}
    </>
);
